import { render, staticRenderFns } from "./ChildAccount.vue?vue&type=template&id=0b765f2e&scoped=true&"
import script from "./ChildAccount.vue?vue&type=script&lang=js&"
export * from "./ChildAccount.vue?vue&type=script&lang=js&"
import style0 from "./ChildAccount.vue?vue&type=style&index=0&id=0b765f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b765f2e",
  null
  
)

export default component.exports